/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Cena sestupně`
};

const da_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Pris faldende`
};

const de_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Preis absteigend`
};

const en_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Price high to low`
};

const es_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Precio descendente`
};

const fr_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Prix décroissant`
};

const hu_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Ár csökkenő`
};

const it_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Prezzo decrescente`
};

const nl_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Prijs aflopend`
};

const pl_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Cena malejąco`
};

const pt_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Preço decrescente`
};

const sv_sort_price_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Pris fallande`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sort_price_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sort_price_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sort_price_desc", locale)
	if (locale === "cs") return cs_sort_price_desc(inputs)
	if (locale === "da") return da_sort_price_desc(inputs)
	if (locale === "de") return de_sort_price_desc(inputs)
	if (locale === "en") return en_sort_price_desc(inputs)
	if (locale === "es") return es_sort_price_desc(inputs)
	if (locale === "fr") return fr_sort_price_desc(inputs)
	if (locale === "hu") return hu_sort_price_desc(inputs)
	if (locale === "it") return it_sort_price_desc(inputs)
	if (locale === "nl") return nl_sort_price_desc(inputs)
	if (locale === "pl") return pl_sort_price_desc(inputs)
	if (locale === "pt") return pt_sort_price_desc(inputs)
	return sv_sort_price_desc(inputs)
};
export { sort_price_desc as "sort.price_desc" }